import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Box } from "@mui/material";
import I18n from "i18next";

import { MzTabContext, MzTabPanel } from "@markaaz/ui/MzTabControls";
import MzAutocomplete from "@markaaz/ui/MzAutocomplete";
import { selectPortfolios } from "store/slices/app";

import {
  loadMonitoringBusiness,
  submitMonitoringBusiness,
  updateMonitoringBusiness
} from "store/slices/monitoringPage";
import { selectBusiness } from "store/slices/monitoringPage";
import BusinessMain from "components/monitoring/business/BusinessMain";
import ComplianceMain from "components/monitoring/compliance/ComplianceMain";

const sx = {
  heading: {
    color: (theme) => theme.palette.darkBlue.c100,
    marginBottom: "40px"
  }
};

const MonitoringConfigurationNew = (props) => {
  const { tab } = useParams();
  const dispatch = useDispatch();
  const business = useSelector(selectBusiness);
  const [ComplianceV, updateComplianceV] = useState(null);
  const [selectedPortfolioId, setSelectedPortfolioId] = useState(null);
  const [businessSubmitInProgress, setBusinessSubmitInProgress] = useState(false);

  const portfolios = useSelector(selectPortfolios);

  const toggleMonitoringBusiness = () => {
    handleBusinessChange({ key: "monitorBusiness", value: !business["monitorBusiness"] });
  };

  function handlePortfolioChange(_, value) {
    setSelectedPortfolioId(value?.id || null);
  }

  function handleBusinessChange(rowData) {
    const changedValue = {};
    changedValue[rowData.key] = rowData.value;
    dispatch(updateMonitoringBusiness(changedValue));
  }

  useEffect(() => {
    if (selectedPortfolioId) {
      dispatch(loadMonitoringBusiness(selectedPortfolioId));
    }
  }, [selectedPortfolioId, dispatch]);

  const handleBusinessSubmitChanges = async () => {
    setBusinessSubmitInProgress(true);

    setTimeout(function () {
      dispatch(submitMonitoringBusiness(selectedPortfolioId));
      setBusinessSubmitInProgress(false);
    }, 1000);
  };

  return (
    <Box>
      <Typography variant="h4" sx={sx.heading}>
        {tab === "business"
          ? I18n.t("monitoringConfiguration.monthlyMonitoring")
          : I18n.t("monitoringConfiguration.complianceMonitoring")}
      </Typography>

      <MzTabContext value={tab}>
        <MzTabPanel value="business">
          <Box>
            <Box sx={{ maxWidth: 420 }}>
              <MzAutocomplete
                label="Portfolio"
                placeholder="Select"
                options={portfolios}
                onChange={handlePortfolioChange}
              />
            </Box>
            {selectedPortfolioId ? (
              <Box>
                <BusinessMain
                  isMonitorDisabled={!business.monitorBusiness}
                  BusinessV={business}
                  handleBusinessChange={handleBusinessChange}
                  isReportFrequencyChecked={!!business.businessReportFrequency}
                  toggleMonitoringBusiness={toggleMonitoringBusiness}
                  submittingMonitoringBusiness={businessSubmitInProgress}
                  handleBusinessSubmit={handleBusinessSubmitChanges}
                />
              </Box>
            ) : null}
          </Box>
        </MzTabPanel>

        <MzTabPanel value="compliance">
          <ComplianceMain ComplianceV={ComplianceV | {}} updateComplianceV={updateComplianceV} />
        </MzTabPanel>
      </MzTabContext>
    </Box>
  );
};

export default MonitoringConfigurationNew;
